import ApiServer from "./ApiServer.ts";
import FizConfig from "./FizConfig.ts";
import deviceId from "./lib/deviceId.ts";
import { loadScript } from "./lib/Async.ts";

var
  defaultRegister=function(onSuccess){if(onSuccess) onSuccess()},
  result : {register:Function} = {register:defaultRegister};

function sendTokenToServer(currentToken :string) :Promise<ApiServer.types.DeviceConfigBean>{
  return ApiServer.devicesetconfig(new ApiServer.types.DeviceConfigBean({
    "deviceId":deviceId,
    "notificationTokenId":currentToken,
    "modelType":'WebFirebase',
    "languageSystem":navigator.languages.join(', ').substring(0,45),
    "partnerType":FizConfig.CONFIG_PARTNER_TYPE,
    "applicationVersion":FizConfig.jsVersion,
    "systemName":navigator.platform.substring(0,500),
    "systemVersion":navigator.userAgent.substring(0,500)
  }));
}


async function initFirebaseNotification(){
  try{
    await loadScript("https://www.gstatic.com/firebasejs/12.13.0/firebase-app-compat.js");
    await loadScript("https://www.gstatic.com/firebasejs/12.13.0/firebase-messaging-compat.js");

    window.firebase.initializeApp(FizConfig.firebase);
    const messaging = window.firebase.messaging();

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return;
    }

    // Try to get existing service worker registration first
    let registration = await navigator.serviceWorker.getRegistration('/');
    if (!registration) {
      // Only register if no service worker is already registered
      registration = await navigator.serviceWorker.register('/sw.php');
    }

    const token = await messaging.getToken({
      vapidKey: FizConfig.firebasevapikey,
      serviceWorkerRegistration: registration
    });
    sendTokenToServer(token);


  }catch(err){
    console.log('An error occurred while retrieving token. ', err);
    ApiServer.devicedelete(deviceId);
  }

}

//if we cannot have a fix deviceId we cannot use all this
if(!deviceId){
}else if(navigator.serviceWorker && FizConfig.serviceWorker && FizConfig.firebase){
  result.register = function(){
    //first of all do not register twice
    result.register = defaultRegister;
    //then wait 10s before launching notifications stuff
    setTimeout(initFirebaseNotification,10000);
  }

}

export default result;